var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPolygon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-polygon",
    transform: "translate(12009 13006)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 24,
    height: 24,
    transform: "translate(-12009 -13006)",
    fill: "#3770fb",
    opacity: 0.002
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4935",
    "data-name": "Group 4935",
    transform: "translate(9816 -28759.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6030",
    "data-name": "Path 6030",
    d: "M-302.466,49.008h-14.282l-5.986,18.967H-299.2Z",
    transform: "translate(-21502.088 15706.992)",
    fill: "#2a3072",
    opacity: 0.202
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Subtitle_1",
    "data-name": "\\u270F\\uFE0F Subtitle 1",
    d: "M-9.5,0a4.836,4.836,0,0,1-3.1-.817,2.785,2.785,0,0,1-.99-2.272,5.787,5.787,0,0,1,.225-1.493,8.218,8.218,0,0,1,.825-1.883l1.575.7a7.982,7.982,0,0,0-.39,1.208,4.21,4.21,0,0,0-.1.877,1.49,1.49,0,0,0,.292.99,1.494,1.494,0,0,0,.81.473,5.011,5.011,0,0,0,1.192.127H-3.69L-3.105,0Zm4.14,0V-2.085H-2.7a4.488,4.488,0,0,0-.405-1.4A9.608,9.608,0,0,0-3.96-4.95l1.89-1.935a13.077,13.077,0,0,1,.78,1.9A7.72,7.72,0,0,1-.937-2.738,8,8,0,0,1-1.44,0Zm0-2.085h.15V0h-.15q-.45,0-.45-1.05T-5.355-2.085Zm-3.09-4.65L-9.9-8.22l1.365-1.47L-7.08-8.22Zm2.61,0L-7.29-8.22-5.9-9.69-4.44-8.22Z",
    transform: "translate(-21804.41 15770.168)",
    fill: "#2a3072"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolygon);
export default __webpack_public_path__ + "static/media/icon-polygon.f1039886c4b86f6f33279ebcfb65b1f9.svg";
export { ForwardRef as ReactComponent };